<template>
    <div>
        <div id="page">
            <Header></Header>
        <div class="wp">
            <div class="infow01">
                <div class="infow01-lab">
                    <div class="lab">认证信息</div>
                </div>
                <div class="infow01-val">
                    <div class="rz-box">
                        <div class="item">
                            <div class="btn" @click="checkCertification('jingjiren')">认证经纪人</div>
                            <div class="tip">如何认证经纪人？</div>
                            <div class="icon" @click="showPop1 = true"></div>
                        </div>
                        <div class="item">
                            <div class="btn" @click="checkCertification('kaifashang')">认证开发商</div>
                            <div class="tip">如何认证开发商？</div>
                            <div class="icon" @click="showPop2 = true"></div>
                        </div>
                        <div class="rz-tips">认证提示：认证经纪人可发布房源信息，认证开发商可发布楼盘信息。同一ID只能认证一种身份，需要更改身份请拨打网站电话400-0080-960</div>
                    </div>
                </div>
            </div>
            <div class="infow01">
                <div class="infow01-lab">
                    <div class="lab">平台等级</div>
                    <div class="lv-tip"><img src="../assets/images/icon-lv1.png" alt="">选址达人<div class="tip">如何获得平台等级？</div><div class="icon" @click="showPop3 = true"></div></div>
                </div>
                <div class="infow01-val">
                    <div class="lv-box">
                        <div class="lv-box-item">
                            <img src="../assets/images/icon-lv2.png" alt=""><div class="lab">选址顾问</div>
                            <div class="progress" :class="{max: userGrade[0] === 100}"><span class="point" :style="'width:' + userGrade[0] + '%'"></span></div>
                        </div>
                        <div class="lv-box-item">
                            <img src="../assets/images/icon-lv1.png" alt=""><div class="lab">选址达人</div>
                            <div class="progress" :class="{max: userGrade[1] === 100}"><span class="point" :style="'width:' + userGrade[1] + '%'"></span></div>
                        </div>
                        <div class="lv-box-item">
                            <img src="../assets/images/icon-lv3.png" alt=""><div class="lab">选址精英</div>
                            <div class="progress" :class="{max: userGrade[2] === 100}"><span class="point" :style="'width:' + userGrade[2] + '%'"></span></div>
                        </div>
                        <div class="lv-box-item">
                            <img src="../assets/images/icon-lv4.png" alt=""><div class="lab">选址专家</div>
                            <div class="progress" :class="{max: userGrade[3] === 100}"><span class="point" :style="'width:' + userGrade[3] + '%'"></span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="infow01">
                <div class="infow01-lab">
                    <div class="lab">基本信息</div>
                    <div v-if="!editInfo" class="edit" @click="editInfo = true">编辑</div>
                </div>
                <div v-show="editInfo" class="infow01-val">
                    <div class="formw01">
                        <div class="formw01-item">
                            <div class="formw01-lab">用户ID</div>
                            <div class="formw01-val">{{ userInfo.member_id }}</div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">昵称</div>
                            <div class="formw01-val">
                                <input class="formw01-inp" type="text" v-model="userInfo.nickname">
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">性别</div>
                            <div class="formw01-val">
                                <select class="formw01-sel" ref="sex" name="sex">
                                    <option v-for="(item, name, index) in objSex" :value="name">{{ item }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">所在城市</div>
                            <div class="formw01-val">
                                <select class="formw01-sel" ref="province" name="province" @change="initCity">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in provinceArr" :value="name" :selected="name == userInfo.province_id">{{ item }}</option>
                                </select>
                                <select class="formw01-sel" ref="city" name="city" @change="initArea">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in cityArr" :value="name" :selected="name == userInfo.city_id">{{ item }}</option>
                                </select>
                                <select class="formw01-sel" ref="area" name="area">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in areaArr" :value="name" :selected="name == userInfo.area_id">{{ item }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">手机号码</div>
                            <div class="formw01-val">{{ userInfo.mobile }}<div class="change-btn" @click="showTel = true">更改手机号</div></div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab valign-top">公司介绍</div>
                            <div class="formw01-val">
                                <textarea class="formw01-area" name="" placeholder="再此输入公司介绍" v-model="userInfo.company_desc"></textarea>
                            </div>
                        </div>
                        <div class="formw01-item-ft">
                            <div class="btn s1" @click="resetEdit">取　消</div>
                            <div class="btn s2" @click="pushInfo">提　交</div>
                        </div>
                    </div>
                </div>
                <div v-show="!editInfo" class="infow01-val">
                    <div class="formw01">
                        <div class="formw01-item">
                            <div class="formw01-lab">用户ID</div>
                            <div class="formw01-val">{{ userInfo.member_id }}</div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">昵称</div>
                            <div class="formw01-val">{{ userInfo.nickname }}</div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">性别</div>
                            <div class="formw01-val">{{ userInfo.re_sex }}</div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">所在城市</div>
                            <div class="formw01-val">{{ userInfo.re_addr }}</div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">手机号码</div>
                            <div class="formw01-val">{{ userInfo.mobile }}</div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab valign-top">公司介绍</div>
                            <div class="formw01-val">{{ userInfo.company_desc }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <Footer></Footer>

        <van-popup v-model="showPop1" :overlay="true">
            <div class="pop-tips-cont">
                <div class="close" @click="showPop1 = false"></div>
                <div class="cont">
                    <p>如何认证为经纪人？</p>
                    <br>
                    <p>1、上传您名片正反面照片。</p>
                    <p>2、提交审核，我们会在1-3个工作日内审核完毕。</p>
                    <p>3、审核通过，成为认证经纪人。</p>
                    <br>
                    <p>认证提示</p>
                    <br>
                    <p>1、认证经纪人可发布房源信息，认证开发商可发布楼盘信息。</p>
                    <p>2、同一ID只能认证一种身份，需要更改身份请拨打网站电话400-0080-960。</p>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="showPop2" :overlay="true">
            <div class="pop-tips-cont">
                <div class="close" @click="showPop2 = false"></div>
                <div class="cont">
                    <p>如何认证为开发商？</p>
                    <br>
                    <p>1、上传您名片正反面照片。</p>
                    <p>2、提交审核，我们会在1-3个工作日内审核完毕。</p>
                    <p>3、审核通过，成为认证开发商。</p>
                    <br>
                    <p>认证提示</p>
                    <br>
                    <p>1、认证经纪人可发布房源信息，认证开发商可发布楼盘信息。</p>
                    <p>2、同一ID只能认证一种身份，需要更改身份请拨打网站电话400-0080-960。</p>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="showPop3" :overlay="true">
            <div class="pop-tips-cont">
                <div class="close" @click="showPop3 = false"></div>
                <div class="cont">
                    <h4>如何获得平台等级？</h4>
                    <br>
                    <p>1、如何获得平台等级？</p>
                    <br>
                    <p>选址中国平台是通过获取经验值进行平台等级提升。选址中国平台等级分为四个等级，即选址顾问，选址达人，选址精英，选址专家。</p>
                    <p>2、经验获取方式有哪些？</p>
                    <br>
                    <p>首次登陆获得50个经验值，发布一个楼盘获得10个经验值，发布一个房源活动8个经验值，发布一个攻略获得6个经验值，发布一个问题获得4个经验值，回答一个问题获得2个经验值，参与投标获得5个经验值，投标中标获得20个经验值，投标委托后提交反馈获得5个经验值，认证身份获得50个经验值，每日登陆获得5个经验值。</p>
                    <p>3、各级别对应经验值范围是？</p>
                    <br>
                    <p>选址顾问：0—200个经验值 ；选址达人：201—800个经验值 ；选址精英：801—1600个经验值 ；选址专家：1601个经验值及以上。</p>
                    <p>4、等级、经验值作用是什么？</p>
                    <br>
                    <p>等级级别高可获得发布楼盘、房源首页优先推荐、展示位置靠前的对应特权，等级级别高用户投标后可优先获得平台分配委托人信息。</p>
                    <p>以上信息选址中国享有最终解释权。</p>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="showTel" :overlay="true">
            <div class="login-form">
                <div class="login-form-item">
                    <div class="login-form-lab">手机号码：</div>
                    <div class="login-form-val"><input class="inp" type="number" v-model="tel"></div>
                </div>
                <div class="login-form-item">
                    <div class="login-form-lab">验证码：</div>
                    <div class="login-form-val"><input class="inp" type="number" v-model="code"><input class="code" type="button" value="获取验证码" @click="getCode" ref="code"></div>
                </div>
                <div class="formw01-item-ft">
                    <div class="btn s1" @click="showTel = false">取　消</div>
                    <div class="btn s2" @click="saveTel">保　存</div>
                </div>
            </div>
        </van-popup>

    </div>
</template>

<script>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { Popup, Picker, Toast } from 'vant'

    export default {
        name: "UserSetting",
        data: function (){
            return {
                editInfo: false,
                showPop1: false,
                showPop2: false,
                showPop3: false,
                showTel: false,
                objGrade: {
                    'guwen': 0,
                    'daren': 1,
                    'jingying': 2,
                    'zhuanjia': 3
                },
                objSex: {0: '不详', 1: '男', 2: '女'},
                provinceArr: {},
                cityArr: {},
                areaArr: {},
                userGrade: [],
                userInfo: {},
                tel: '',
                code: ''
            }
        },
        components: {
            Header, Footer,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Toast.name]: Toast
        },
        mounted: function () {
            this.initData();
        },
        methods: {
            initData: function () {
                var _this = this;
                _this.api.getUserInfo().then(function(response){
                    let data = response.member_info;
                    let key = _this.objGrade[data.user_grade];
                    for (var i = 0; i < 4; i++) {
                        if (i < key) {
                            _this.userGrade.push(100)
                        } else if (i === key) {
                            _this.userGrade.push(data.experience_value)
                        } else {
                            _this.userGrade.push(0)
                        }
                    }
                    _this.userInfo = data;
                    _this.$set(_this.userInfo, 're_sex', _this.objSex[data.sex]);
                    _this.api.getAreaName(data.province_id, data.city_id, data.area_id).then(function(response){
                        _this.userInfo.re_addr = response.areaname
                    })
                    _this.selProvice();
                    _this.selCity(data.province_id);
                    _this.selArea(data.city_id);
                })
            },
            selProvice () {
                let result = {};
                const _this = this;
                _this.api.getProvinces().then(function(response){
                    for (let i in response) {
                        result[response[i].id] = response[i].name;
                    }
                    _this.$set(_this, 'provinceArr', result);
                })
            },
            selCity (id) {
                let result = {};
                const _this = this;
                _this.api.getCitys(id).then(function(response){
                    for (let i in response.area_list) {
                        result[response.area_list[i].id] = response.area_list[i].name;
                    }
                    _this.$set(_this, 'cityArr', result);
                })
            },
            selArea (id) {
                let result = {};
                const _this = this;
                _this.api.getAreas(id).then(function(response){
                    for (let i in response.area_list) {
                        result[response.area_list[i].id] = response.area_list[i].name;
                    }
                    _this.$set(_this, 'areaArr', result);
                })
            },
            initCity () {
                let id = this.$refs.province.options[this.$refs.province.selectedIndex].value;
                this.selCity(id);
                this.areaArr = [];
            },
            initArea () {
                let id = this.$refs.city.options[this.$refs.city.selectedIndex].value;
                this.selArea(id);
            },
            pushInfo () {
                const _this = this;
                let param = new FormData();
                param.append('province', this.$refs.province.options[this.$refs.province.selectedIndex].value);
                param.append('city', this.$refs.city.options[this.$refs.city.selectedIndex].value);
                param.append('city', this.$refs.city.options[this.$refs.city.selectedIndex].value);
                param.append('district', this.$refs.area.options[this.$refs.area.selectedIndex].value);
                param.append('nickname', this.userInfo.nickname);
                param.append('sex', this.$refs.sex.options[this.$refs.sex.selectedIndex].value);
                param.append('introduction', this.userInfo.introduction);
                param.append('company_desc', this.userInfo.company_desc);
                _this.api.editUserInfo(param).then(function(response){
                    if (response.status == 1) {
                        Toast(response.msg);
                        _this.editInfo = false;
                        _this.initData();
                    }
                })
            },
            resetEdit: function () {
                this.initData();
                this.editInfo = false;
            },
            getCode () {
                const _this = this;
                let telreg=/^[1][3,4,5,7,8][0-9]{9}$/;
                if (_this.tel === '') {
                    Toast('手机号不能为空')
                } else if (!telreg.test(_this.tel)) {
                    Toast('手机号格式不正确')
                } else {
                    let params = new FormData();
                    params.append('mobile', _this.tel);
                    _this.api.sendMsg(params).then(function (response) {
                        Toast(response.msg);
                        if (response.status === 1) {
                            _this.countTime(_this.$refs.code);
                        }
                    })
                }
            },
            saveTel () {
                const _this = this;
                let params = new FormData();
                params.append('mobile', _this.tel);
                params.append('captcha', _this.code);
                _this.api.saveMobile(params).then(function(response){
                    Toast(response.msg);
                    if (response.status == 1) {
                        _this.showTel = false;
                    }
                })
            },
            checkCertification(type){
                const _this = this;
                _this.api.checkCertification({
                    type: type
                }).then(function(response){
                    if (response.status == 2) {
                        Toast(response.msg)
                    } else {
                        _this.$router.push({
                            path: 'certification',
                            query: {type: type}
                        })
                    }
                })
            },
            countTime (el) {
                var count = 60;
                (function fun () {
                    if (count === 0) {
                        count = 60;
                        el.value = '获取验证码';
                        el.disabled = false;
                        return
                    } else {
                        count--;
                        el.value = count + 's';
                        el.disabled = true;
                    }
                    setTimeout(function(){fun()},1000)
                })()
            }
        }
    }
</script>

<style scoped>
    .login-form {
        margin: 0;padding: .3rem;width: 80vw;
    }
</style>
